import React from "react";

interface ProvetContactDetailsSectionHeaderProps {
  /** Section title text */
  title: string;
}

/**
 * Section header component for contact details form sections.
 *
 * Displays a formatted section title with consistent styling.
 *
 * @param title - The section title to display
 *
 * @example
 * ```tsx
 * <ProvetContactDetailsSectionHeader title="Customer Information" />
 * ```
 */
export const ProvetContactDetailsSectionHeader = ({
  title
}: ProvetContactDetailsSectionHeaderProps) => (
  <span className="block font-guardian uppercase text-dark-blue md:text-distinct-sm">
    {title}
  </span>
);

export default ProvetContactDetailsSectionHeader;
